import React from 'react';
import { X, LogOut } from 'lucide-react';
interface LogoutConfirmModalProps {
  onClose: () => void;
  onConfirm: () => void;
}
export function LogoutConfirmModal({
  onClose,
  onConfirm
}: LogoutConfirmModalProps) {
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-555">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md" data-id="element-556">
        <div className="relative bg-black/90 rounded-xl p-6" data-id="element-557">
          <div className="flex justify-between items-center mb-4" data-id="element-558">
            <h2 className="text-xl font-bold" data-id="element-559">Çıkış Yap</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-560">
              <X className="w-6 h-6" data-id="element-561" />
            </button>
          </div>
          <div className="py-4 text-center" data-id="element-562">
            <div className="flex justify-center mb-4" data-id="element-563">
              <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center" data-id="element-564">
                <LogOut className="w-8 h-8 text-red-400" data-id="element-565" />
              </div>
            </div>
            <p className="text-lg" data-id="element-566">Çıkış yapmak istediğinize emin misiniz?</p>
          </div>
          <div className="flex justify-center gap-3 mt-4" data-id="element-567">
            <button onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-568">
              İptal
            </button>
            <button onClick={onConfirm} className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 rounded-lg hover:opacity-90 transition-opacity" data-id="element-569">
              Evet, Çıkış Yap
            </button>
          </div>
        </div>
      </div>
    </div>;
}